<ng-container *ngIf="response && showResponse">
    <div [innerHTML]="response"></div>
    <div> {{ response}}</div>
</ng-container>

 
<div [innerHTML]="safeHtml | safe:'html'" runScripts></div>
 